module.exports = __webpack_public_path__ + "static/media/comment_blue_active1.e21b8397.svg";